import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import InscriptionForm from './InscriptionForm';
import {
  fetchStudentSubject,
  saveStudentSubject,
  getFormDatas,
  getInscriptionAllSubjects,
} from '../../../redux/actions/studentSubjectsActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';

import LoadingSpinner from '../../../shared/components/LoadingSpinner';

class SubjectsInscriptionContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mallas: [],
      semesters: [],
      students: [],
      subjects: [],
    };
    this.filterSubjects = this.filterSubjects.bind(this);
  }

  componentDidMount() {
    this.fetchFormData(0);
    this.fetchCurrentStudentSubject();
  }

  fetchCurrentStudentSubject = () => {
    const { id, history } = this.props;
    if (!id) {
      this.setState({ studentSubject: { id: 0 } });
      return;
    }

    fetchStudentSubject({
      id,
      onSuccess: (dto) => {
        this.fetchAllSubjects(dto.mallaId);

        const studentSubject = {
          ...dto,
          malla: {
            value: dto.mallaId,
            label: `${dto.mallaNombre}`,
          },
          semestre: {
            value: dto.semestreId,
            label: `${dto.semestreNombre}`,
          },
          materia: {
            value: dto.materiaPeriodoId,
            label: `${dto.materiaCodigo} - ${dto.materiaNombre} - ${dto.seccion}`,
          },
          alumno: {
            value: dto.perfilAlumnoId,
            label: `${dto.numeroLegajo}: ${dto.nombreAlumno} ${dto.apellidoAlumno}`,
          },
        };

        this.setState({ studentSubject });

        this.fetchFormData(dto.perfilAlumnoId);
      },
      onError: (error) => {
        if (error && error.status === 404) {
          createErrorMessage('La inscripción a esta materia no existe');
          history.push('/pages/student-subjects');
        } else {
          createErrorMessage('Error al intentar cargar los datos de la inscripción');
        }
      },
    });
  }

  fetchFormData = (perfilAlumnoId) => {
    const { id } = this.props;
    getFormDatas({
      isNew: !(id > 0),
      perfilAlumnoId,
      onSuccess: (viewModel) => {
        this.setState({ ...viewModel });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos de mallas');
      },
    });
  }

  fetchAllSubjects = (mallaId = 0) => {
    getInscriptionAllSubjects({
      mallaId,
      onSuccess: ({ subjects = [] }) => {
        this.setState({
          subjects,
        });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos de mallas');
      },
    });
  }

  handleSubmit = (values) => {
    const {
      malla,
      semestre,
      materia,
      alumno,
    } = values;

    const { value: mallaId } = malla;
    const { value: semestreId } = semestre;
    const { value: materiaPeriodoId } = materia;
    const { value: perfilAlumnoId } = alumno;
    const params = {
      ...values,
      semestreId,
      mallaId,
      materiaPeriodoId,
      perfilAlumnoId,
    };
    const { history } = this.props;
    saveStudentSubject(
      params,
      {
        onSuccess: () => {
          createSuccessMessage('Inscripción guardada exitosamente');
          history.push('/pages/student-subjects');
        },
        onError: (error) => {
          if (error.message) {
            createWarningMessage(error.message);
          } else {
            createErrorMessage('Ocurrió un error al intentar guardar la inscripción');
          }
        },
      },
    );
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  handleOnFilterChange = (objectKey, idKey, value) => {
    const { studentSubject } = this.state;

    if (objectKey === 'malla') {
      this.fetchAllSubjects(value.value || 0);
    }

    this.setState({
      [idKey]: value.value,
      studentSubject: {
        ...studentSubject,
        materia: {
          value: 0,
          label: '-',
        },
        [objectKey]: value,
      },
    });
  }

  filterSubjects = () => {
    const { mallaId = 0, semestreId = 0, subjects } = this.state;
    if (!subjects) return [];

    return subjects
      .filter(s => s.mallaId === mallaId || mallaId === 0)
      .filter(s => s.semestreId === semestreId || semestreId === 0)
      .map(({
        id, materiaCodigo, materia, seccion,
      }) => ({
        value: id,
        label: `${materiaCodigo} - ${materia} - ${seccion}`,
      }));
  }

  render() {
    const { id, history } = this.props;

    const {
      studentSubject,
      mallas = [],
      semesters = [],
      students = [],
    } = this.state;

    const subjects = this.filterSubjects();

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nueva'} inscripción
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              la informaci&oacute;n de la inscripción
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!(mallas && semesters && subjects && studentSubject)
              ? (<LoadingSpinner />)
              : (
                <InscriptionForm
                  {...studentSubject}
                  onSubmit={this.handleSubmit}
                  onBack={this.handleOnBack}
                  initialValues={studentSubject}
                  history={history}
                  mallas={mallas}
                  semesters={semesters}
                  subjects={subjects}
                  onFilterChanges={this.handleOnFilterChange}
                  enableReinitialize
                  alumnos={students}
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

SubjectsInscriptionContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default SubjectsInscriptionContainer;
